import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { useAddonContext } from '../../contexts/AddonContext';
import Spinner from '../UI/Spinner';

interface ProtectedRouteProps {
  children: React.ReactNode;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
  const { currentUser, isLoading: authLoading } = useAuth();
  const { loading: addonLoading } = useAddonContext();

  const isLoading = authLoading || (currentUser && addonLoading);

  console.log("ProtectedRoute: isLoading:", isLoading, "authLoading:", authLoading, "addonLoading:", addonLoading, "currentUser:", currentUser?.email || "null");

  // Show loading spinner while checking authentication state
  if (isLoading) {
    console.log("ProtectedRoute: Showing loading spinner");
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-100">
        <Spinner size="lg" color="border-green-500" />
      </div>
    );
  }

  // If user is not authenticated, redirect to login
  if (!currentUser) {
    console.log("ProtectedRoute: No user, redirecting to login");
    return <Navigate to="/login" replace />;
  }

  // If user is authenticated, render the protected content
  console.log("ProtectedRoute: User authenticated, rendering children");
  return <>{children}</>;
};

export default ProtectedRoute;